<template>
  <div class="flex flex-col gap-2">
    <div v-for="(value, name) in data" :key="name" class="flex flex-row justify-between">
      <div
        class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem] font-medium text-[#2B2926]"
      >
        {{ name }}
      </div>
      <div
        class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] font-bold text-[#2B2926]"
      >
        {{ value }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
